<template>
    <field>
      <label>Profile:</label>
      <div class="is-flex align-center mt-10" >
        <toggle v-tooltip="toggleTooltip" v-model="checked" :isEditable="isEditable" />  <span class="ml-20">{{ formattedAccess }}</span>
      </div>
    </field>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Field from '@/components/general/field'
import Toggle from '@/components/toggle'
import Heading from '@/components/general/heading'

export default {
  name: 'profile-toggle',
  components: {
    Field,
    Toggle,
    Heading
  },
  data () {
    return {
      isPublic: true,
      isEditable: true

    }
  },
  computed: {
    ...mapState('jobseekerProfiles', {
      profile: 'jobseekerProfile'
    }),
    toggleTooltip () {
      return this.checked ? this.$t('profile.tooltipView') : this.$t('profile.tooltipHidden')
    },
    formattedAccess () {
      return this.checked ? this.$t('profile.roleInPublic') : this.$t('profile.roleInPrivate')
    },
    checked: {
      get () {
        if (this.profile) return this.profile.isPublic
        return this.isPublic
      },
      set (value) {
        this.isPublic = value
        this.updateJobseekerProfileVisibility({isPublic: value})
      }
    }
  },
  methods: {
    ...mapActions('jobseekerProfiles', [
      'updateJobseekerProfile',
      'updateJobseekerProfileVisibility'
    ])
  }

}
</script>

<style lang="scss" scoped>
.align-center{
  align-items: center;
}
.ml-20{
  margin-left: 20px;
}
.mt-10{
  margin-top: 10px
}
</style>



// WEBPACK FOOTER //
// src/components/profile/profile-toggle.vue